import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { TransfersPage } from './_dashboard.inventory.transfers'

export const Route = createFileRoute('/_dashboard/inventory/transfers/')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: TransfersIndexPage,
})

function TransfersIndexPage() {
  return <TransfersPage selectedId={undefined} />
}
